import React, { useState } from 'react';
import styled from 'styled-components';
import { useNavigate, useLocation } from 'react-router-dom';
import RegisterModal from '../components/RegisterModal';

// Styled Components
const HeaderContainer = styled.header`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 80px;
    background: rgba(12, 12, 12, 0.95);
    backdrop-filter: blur(20px);
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 40px;
    z-index: 1000;
    transition: all 0.3s ease;

    @media (max-width: 768px) {
        padding: 0 20px;
        height: 70px;
    }
`;

const LogoContainer = styled.div`
    display: flex;
    align-items: center;
    cursor: pointer;
    transition: transform 0.3s ease;

    &:hover {
        transform: scale(1.05);
    }
`;

const Logo = styled.img`
    height: 100px;
    width: auto;
    border-radius: 8px;

    @media (max-width: 768px) {
        height: 35px;
    }
`;

const NavSection = styled.div`
    display: flex;
    align-items: center;
    gap: 40px;

    @media (max-width: 768px) {
        gap: 20px;
    }
`;

const NavLink = styled.a<{ $isActive?: boolean }>`
    color: ${props => props.$isActive ? '#f56607' : '#ffffff'};
    text-decoration: none;
    font-weight: 500;
    font-size: 1em;
    cursor: pointer;
    transition: all 0.3s ease;
    position: relative;
    padding: 8px 0;

    &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: ${props => props.$isActive ? '100%' : '0%'};
        height: 2px;
        background: #f56607;
        transition: width 0.3s ease;
    }

    &:hover {
        color: #f56607;
        &::after {
            width: 100%;
        }
    }

    @media (max-width: 768px) {
        font-size: 0.9em;
    }
`;

const RegisterButton = styled.button`
    background: linear-gradient(135deg, #f56607 0%, #ff8c00 100%);
    color: white;
    border: none;
    border-radius: 10px;
    padding: 12px 30px;
    font-weight: 600;
    font-size: 1em;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 4px 15px rgba(245, 102, 7, 0.3);

    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 20px rgba(245, 102, 7, 0.4);
    }

    &:active {
        transform: translateY(0);
    }

    @media (max-width: 768px) {
        padding: 10px 20px;
        font-size: 0.9em;
    }
`;

const HeaderSpacer = styled.div`
    height: 80px;

    @media (max-width: 768px) {
        height: 70px;
    }
`;

// Main Header Component
const Header: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [isRegisterModalOpen, setIsRegisterModalOpen] = useState(false);

    const handleLogoClick = () => {
        navigate('/domov');
    };

    const handleDatabaseClick = () => {
        navigate('/databaza-tipov');
    };

    const handleRegisterClick = () => {
        setIsRegisterModalOpen(true);
    };

    const handleCloseRegisterModal = () => {
        setIsRegisterModalOpen(false);
    };

    const handleRegisterSuccess = () => {
        console.log('Registration successful!');
        // You can add any post-registration logic here
        // For example: show success message, redirect, etc.
    };

    const isDatabaseActive = location.pathname === '/databaza-tipov';

    return (
        <>
            <HeaderContainer>
                <LogoContainer onClick={handleLogoClick}>
                    <Logo
                        src="/g3.png"
                        alt="G3 Logo"
                        onError={(e) => {
                            e.currentTarget.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDUiIGhlaWdodD0iNDUiIHZpZXdCb3g9IjAgMCA0NSA0NSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjQ1IiBoZWlnaHQ9IjQ1IiByeD0iOCIgZmlsbD0iI0Y1NjYwNyIvPgo8dGV4dCB4PSIyMiIgeT0iMjgiIGZvbnQtZmFtaWx5PSJBcmlhbCIgZm9udC1zaXplPSIxNiIgZm9udC13ZWlnaHQ9ImJvbGQiIGZpbGw9IndoaXRlIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIj5HMzwvdGV4dD4KPC9zdmc+';
                        }}
                    />
                </LogoContainer>

                <NavSection>
                    <NavLink
                        $isActive={isDatabaseActive}
                        onClick={handleDatabaseClick}
                    >
                        Databáza tipov
                    </NavLink>

                    <RegisterButton onClick={handleRegisterClick}>
                        Zaregistrovať sa
                    </RegisterButton>
                </NavSection>
            </HeaderContainer>

            <HeaderSpacer />

            <RegisterModal
                isOpen={isRegisterModalOpen}
                onRequestClose={handleCloseRegisterModal}
                onRegister={handleRegisterSuccess}
            />
        </>
    );
};

export default Header;